export const CHART_SAVE = 'CHART_SAVE';
export const CHART_SAVE_CLEAR = 'CHART_SAVE_CLEAR';